/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { getSize } from "../../utils/size";
import { classnames, combinePrefixes } from "../../utils/text";
import { Modal as OriginModal } from "reactstrap";
import ModalHeader from "./ModalHeader";
import ModalFooter from "./ModalFooter";
import ModalTab from "./ModalTab";
import systemAlert from "../../utils/systemAlert";
import { isFunction } from "lodash";
import { shallowEqual, useSelector } from "react-redux";
import closeAllPopup from "../../utils/popup";

const Modal = React.forwardRef(
  (
    {
      type = "default", // fit : 패딩이 없는 경우
      size = "lg", // x-lg, lg, md, sm ,x-sm
      className = "",
      isOpen,
      children,
      centered = true,
      toggle = () => { },
      close,
      ...props
    },
    ref
  ) => {
    const {
      popupToggle
    } = useSelector(
      (store) => ({
        popupToggle: store.Data.popupToggle
      }),
      shallowEqual
    );

    const [isSystemAlertActive, setIsSystemAlertActive] = useState(false); // systemAlert 활성화 상태 추적
    const [isFirst, setIsFirst] = useState(true); // 처음 실행인가?

    const _close = () => {
      setIsSystemAlertActive(false); // systemAlert 상태 비활성화
      if (isFunction(close) && isOpen) close()
    }
    useEffect(() => {
      if (isFirst) {
        setIsFirst(false)
      } else {
        _close()
      }
    }, [popupToggle])



    useEffect(() => {
      const handleEscKey = (event) => {
        if (event.key === "Escape" && isOpen) {
          systemAlert(`전체 팝업을 닫으시겠습니까?`, {

            buttons: [
              {
                color: 'text',
                label: '취소'
              },
              {
                label: '닫기',
                onClick: () => {
                  closeAllPopup()
                  systemAlert(false)
                  event.stopPropagation();
                }
              }
            ]
          });
          setIsSystemAlertActive(true); // systemAlert 활성화 상태 설정
        }
      };

      const handleBacktickKey = (event) => {
        if (event.key === "`" && isSystemAlertActive) {
          closeAllPopup()
          systemAlert(false)
          event.stopPropagation();
        }
      };

      document.addEventListener("keydown", handleEscKey);
      document.addEventListener("keydown", handleBacktickKey);

      // 컴포넌트가 언마운트될 때 이벤트 해제
      return () => {
        document.removeEventListener("keydown", handleEscKey);
        document.removeEventListener("keydown", handleBacktickKey);
      };
    }, [isOpen, close, isSystemAlertActive]);


    return (
      <>
        <OriginModal
          isOpen={isOpen}
          toggle={toggle}
          centered={centered}
          className={classnames(
            combinePrefixes(
              `custom-modal`,
              [type.toLowerCase(), getSize(size)],
              "-",
              true
            ),
            className
          )}
          ref={ref}
          {...props}
        >
          {close &&
            <button
              type="button"
              className="close"
              onClick={close}
              aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          }
          {children}
        </OriginModal>
      </>
    );
  }
);

export { ModalHeader, ModalTab, ModalFooter };

export default Modal;
